import { Component, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';

import { Subject, Observable } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

import { Selectors, AppState, Actions as RootActions } from 'store/root-reducer';
import { CustomerActionTypes } from 'store/actions/customer.actions';

import { CustomerCrpDataSource } from 'modules/shared/data-source/crp-list.data-source';

import { DialogService } from 'modules/shared/components/dialog/dialog.service';

import { Role } from 'modules/shared/models/role.models';

@Component({
  selector: 'artemis-crp-list-card',
  templateUrl: './crp-list-card.component.html',
  styleUrls: ['./crp-list-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CrpListCardComponent implements OnInit, OnDestroy {

  private unSubscribe: Subject<any> = new Subject<any>();
  currentCustomerId: number;
  loading$: Observable<boolean>;

  displayedColumns: string[] = ['name', 'roles', 'status', 'actions'];
  dataSource: CustomerCrpDataSource;
  readonly pageSizeOptions: Array<number> = [5, 10, 15];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  isUserOnlyL1$: Observable<boolean>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private action: Actions,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private dialogService: DialogService
  ) {
    this.isUserOnlyL1$ = this.store
      .select(Selectors.auth.getUserRoles)
      .pipe(map((roles: Array<Role>) => {
        return roles && !roles.some((role: Role) => role.name === 'L2' || role.name === 'L3');
      }));
  }

  ngOnInit() {
    this.getLoadingStatus();

    this.currentCustomerId = +this.activatedRoute.snapshot.params['id'];
    this.dataSource = new CustomerCrpDataSource(this.store, this.currentCustomerId);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator.pageSizeOptions = this.pageSizeOptions;
    this.dataSource.loadCrps();
    this.cdRef.detectChanges();

    // this.store.dispatch(new RootActions.customer.GetCrps(<CrpPayload>{
    //   customerId: this.currentCustomerId
    // }));
    this.action.pipe(
      ofType(RootActions.customer.CustomerActionTypes.RELOAD_CRP_LIST),
      takeUntil(this.unSubscribe)
    ).subscribe(() => {
      this.dataSource.loadCrps();
    });
    this.action.pipe(
      ofType(RootActions.customer.CustomerActionTypes.CREATE_OR_UPDATE_CRP_SUCCESS),
      takeUntil(this.unSubscribe)
    ).subscribe(() => {
      this.dataSource.loadCrps();
    });
  }

  /**
   * Get loading status from store
   * @method getLoadingStatus
   */
  private getLoadingStatus(): void {
    this.loading$ = this.store.select(Selectors.customer.getLoading)
      .pipe(
        takeUntil(this.unSubscribe),
        map((customerLoading: Array<CustomerActionTypes>) => {
          return customerLoading.includes(CustomerActionTypes.GET_CRPS_NO_PRIMARY);
        })
      );
  }

  reloadCrps() {
    this.dataSource.loadCrps();
  }

  toAddCrp() {
    this.router.navigateByUrl(`/customers/${this.currentCustomerId}/edit/crp-add`);
  }

  deleteCrp(crpId: number) {
    this.dialogService.confirm('Are you sure you want to delete?', 'NOTICE').subscribe(
      res => {
        if (res === 'submit') {
          this.store.dispatch(new RootActions.record.DeleteCrp(crpId));
        }
      }
    );
  }

  searchCrpList(filterValue: string): void {
    this.paginator.pageIndex = 0;
    this.dataSource.search(filterValue.trim().toLowerCase());
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
